import { render } from "./PackageDetailPage.vue?vue&type=template&id=3030fed4"
import script from "./PackageDetailPage.vue?vue&type=script&lang=js"
export * from "./PackageDetailPage.vue?vue&type=script&lang=js"

import "./PackageDetailPage.vue?vue&type=style&index=0&id=3030fed4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__